export enum BaseRoutes {
  Club = "Club",
  Unauthenticated = "Unauthenticated",
  NotFound = "NotFound",
  NoNav = "NoNav",
  TodayTeeSheetHack = "TodayTeeSheetHack",
  Legacy = "Legacy",
}
